import {IActionLogResponse, IMenu, IStructureUserDetails, IStructureUserResponse, IUserContactResponse, IUserProfile} from '@/interfaces';
import { MainState, AppNotification } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';


export const mutations = {
    setToken(state: MainState, payload: string) {
        state.token = payload;
    },
    setLoggedIn(state: MainState, payload: boolean) {
        state.isLoggedIn = payload;
    },
    setLogInError(state: MainState, payload: boolean) {
        state.logInError = payload;
    },
    setUserProfile(state: MainState, payload: IUserProfile) {
        state.userProfile = payload;
    },
    setMainMenu(state: MainState, payload: IMenu[]) {
        state.mainMenu = payload;
    },
    setDropdownMenu(state: MainState, payload: IMenu[]) {
        state.dropdownMenu = payload;
    },
    setDashboardMiniDrawer(state: MainState, payload: boolean) {
        state.dashboardMiniDrawer = payload;
    },
    setDashboardShowDrawer(state: MainState, payload: boolean) {
        state.dashboardShowDrawer = payload;
    },
    addNotification(state: MainState, payload: AppNotification) {
        state.notifications.push(payload);
    },
    removeNotification(state: MainState, payload: AppNotification) {
        state.notifications = state.notifications.filter((notification) => notification !== payload);
    },
    setStructureResponse(state: MainState, payload: IUserContactResponse) {
        state.structureResponse = payload;
    },
    setWaitingUsersResponse(state: MainState, payload: IStructureUserResponse) {
        state.waitingUsersResponse = payload;
    },
    setStructureUserDetails(state: MainState, payload: IStructureUserDetails) {
        state.structureUserDetails = payload;
    },
    setActionLogsResponse(state: MainState, payload: IActionLogResponse) {
        state.actionLogsResponse = payload;
    },
    setAppConfigs(state: MainState, payload: any) {
        state.appConfigs = payload;
    },
};

const {commit} = getStoreAccessors<MainState | any, State>('');

export const commitSetDashboardMiniDrawer = commit(mutations.setDashboardMiniDrawer);
export const commitSetDashboardShowDrawer = commit(mutations.setDashboardShowDrawer);
export const commitSetLoggedIn = commit(mutations.setLoggedIn);
export const commitSetLogInError = commit(mutations.setLogInError);
export const commitSetToken = commit(mutations.setToken);
export const commitSetUserProfile = commit(mutations.setUserProfile);
export const commitSetMainMenu = commit(mutations.setMainMenu);
export const commitSetDropdownMenu = commit(mutations.setDropdownMenu);
export const commitAddNotification = commit(mutations.addNotification);
export const commitRemoveNotification = commit(mutations.removeNotification);
export const commitSetStructureResponse = commit(mutations.setStructureResponse);
export const commitSetWaitingUsersResponse = commit(mutations.setWaitingUsersResponse);
export const commitSetStructureUserDetails = commit(mutations.setStructureUserDetails);
export const commitSetActionLogsResponse = commit(mutations.setActionLogsResponse);
export const commitSetAppConfigs = commit(mutations.setAppConfigs);
